import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=1961c4b7&"
import script from "./ProductGallery.vue?vue&type=script&lang=js&"
export * from "./ProductGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports